<template>
  <div class="footer">
<footer class="footer_area">
   <div class="container">
      <div class="row footer_inner">
         <div class="col-lg-5 col-sm-6">
            <aside class="f_widget ab_widget">
               <div class="f_title">
                  <h3>ℹ️ About US</h3>
               </div>
               <p>GitLeaf™️ is an IT Brand which goes align with modern technological advancements in order to satisfy their customer requirements.
               </p>
               <p>
                  GitLeaf™️ ©️ 2024. All rights reserved. 
               </p>
            </aside>
         </div>
         <div class="col-lg-5 col-sm-6">
            <aside class="f_widget news_widget">
               <div class="f_title">
                  <h3>📧 Newsletter</h3>
               </div>
               <p>Stay updated with our latest trends</p>
               <div id="mc_embed_signup">
                  <div class="subscribe_form relative">
                     <div class="input-group d-flex flex-row">
                        <input v-model="input.subscribe" placeholder="Enter email address" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Email Address '" style="border : 1px solid #6465; color: black;" 
                           required="" type="email">
                        <button v-on:click="subscribe()" class="btn sub-btn"><span class="lnr lnr-arrow-right"></span></button>
                     </div>
                     <div class="mt-10 info"></div>
                  </div><br>
                  <br><strong> Sri Lanka 🇱🇰 </strong>
               </div>
            </aside>
         </div>
         <div class="col-lg-2">
            <aside class="f_widget social_widget">
               <div class="f_title">
                  <h3>👐 Hello GitLeaf</h3>
               </div>
               <p>📲 HOTLine</p>+94 (77) 931 3495 (WhatsApp Only)
               <br><br><br>
               <p>✉️ HOTMail</p>contact@gitleaf.com          
            </aside>
         </div>
      </div>
   </div>
</footer>
<div class="quick-links">
   <ul>
      <li><router-link to="/privacy-policy"><a>privacy-policy</a></router-link></li>
      <li><router-link to="/help"><a>help</a></router-link></li>
      <li title="It's your logged in Information. Click to More info.."><router-link to="/ipinfo">{{country}} {{ip}} [{{country_code}}]</router-link></li>
   </ul>
</div>
</div>
</template>

<script>

import axios from 'axios';


export default {
   name: "Footer",
   data() {
      return {
         input:{
            subscribe : ""
         },
         country:  "",
         ip: "",
         country_code: ""
      };
   },
   mounted() {

      axios({
         method: 'get',
         url: 'https://api.2ip.ua/geo.json',
      })
      .then(response => {
         this.country = response.data.country;   
         this.ip = response.data.ip; 
         this.country_code = response.data.country_code; 
      })
      .catch(() => console.log('error occured'))  
   },
   methods: {
      subscribe() {
         if(this.input.subscribe != "")
         {
            if(this.validateEmail(this.input.subscribe))
            {
               axios({
                 method: 'get',
                 url: 'https://gl-mail.herokuapp.com/api/subscribe?email='+this.input.subscribe,
               })
               .then(response => {
                 
                  this.input.subscribe = "";
                  this.$toasted.show(response.data.message, { 
                     theme: "toasted-primary", 
                     position: "top-right", 
                     duration : 5000
                  });
               })
               .catch(() => console.log('error occured'))  
            } 
            else 
            {     
               this.$toasted.show("Invalid Email Address", { 
                  theme: "toasted-primary", 
                  position: "top-right", 
                  duration : 5000
               });
            }          
         }
         else
         {
            this.$toasted.show("Please enter valid email address", { 
               theme: "toasted-primary", 
               position: "top-right", 
               duration : 5000
            });
         }
      },
      validateEmail(value){
         if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value))
         {
            return true;
         } else{
            return false;
         } 
      }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
router-link {
  color: #16a085;
}
.quick-links {
   width: 100%;
   height: 50px;
   background-color: black;
   color: white;
}
ul > li {
    display: inline-block;
    zoom:1;
    float: right;
    margin-top: 15px; 
    margin-right: 15px; 
}
</style>
